import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import Vue from 'vue';
import Router from 'vue-router';
import routers from './routers';
import store from '@/store';
import iView from 'view-design';
import i18n from '@/locale';
import { setToken, getToken, canTurnTo, setTitle, getRouteWithPath } from '@/libs/util';
import config from '@/config';
var homeName = config.homeName;
Vue.use(Router);
var router = new Router({
  mode: 'history',
  routes: routers
});
var LOGIN_PAGE_NAME = 'login';
var intoRouter = ['login', 'register', 'forget'];

var turnTo = function turnTo(to, access, next) {
  if (canTurnTo(to.name, access, routers)) {
    next(); // 有权限，可访问
  } else {
    next({
      replace: true,
      name: 'error_401'
    }); // 无权限，重定向到401页面
  }
};

router.beforeEach(function (to, from, next) {
  iView.LoadingBar.start();
  var token = getToken(); // var getPath= sessionStorage.getItem('currPath');
  // console.log("getPath="+getPath);
  // console.log("lastUrl="+lastUrl);

  if (!token && intoRouter.indexOf(to.name) > -1) {
    // 未登录且要跳转的页面不是登录页
    next();
  } else if (!token && intoRouter.indexOf(to.name) === -1) {
    // 未登录且要跳转的页面是登录页
    next({
      name: LOGIN_PAGE_NAME
    }); // 跳转
  } else if (!token && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({
      name: LOGIN_PAGE_NAME // 跳转到登录页

    });
  } else if (!token && to.name === LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面是登录页
    next(); // 跳转
  } else if (token && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({
      name: homeName // 跳转到homeName页

    });
  } else {
    if (store.state.user.hasGetInfo) {
      turnTo(to, store.state.user.access, next);
    } else {
      // turnTo(to, store.state.user.access, next)
      store.dispatch("handleGetMenu", {}).then(function (res) {
        store.dispatch('getUserInfo').then(function (user) {
          turnTo(to, user.access, next);
        }).catch(function () {
          setToken('');
          next({
            name: 'login'
          });
        });
      });
    }
  }
});
router.afterEach(function (to) {
  setTitle(to, router.app, i18n.t('homeTitle'));
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});
export default router;